var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kanban-column col-md-3 col-sm-12"},[_c('div',{staticClass:"kanban-header"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',[_c('span',{staticClass:"badge badge-info"},[_vm._v(_vm._s(_vm.taskCount))])])]),_vm._v(" "),_c('div',{staticClass:"kanban-body"},_vm._l((_vm.tasks),function(task){return _c('kanban-card',{key:task.id,attrs:{"task":task,"canAssign":_vm.taskStatus === 0,"availableWorkers":_vm.workers[task.project.id]}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./assets/js/components/KanbanColumn.vue?vue&type=template&id=186f06d9&
// module id = 435
// module chunks = 0